import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

import type { RentSummary } from '@features/banking/types'

/** Predpisy, ktoré by k danej platbe mohli patriť. Backend ich hľadá podľa
 * variabilného symbolu a sumy, takže admin nemusí nič prepisovať ručne. */
export function useNotificationCandidates(notificationId?: string) {
  async function getCandidates(): Promise<RentSummary[]> {
    const res = await apiClient.get<RentSummary[]>(
      `${BACK_OFFICE_PREFIX}bank-notifications/${notificationId}/candidates`
    )
    return res.data
  }

  return useQuery({
    queryFn: getCandidates,
    queryKey: ['bank-notification-candidates', notificationId],
    enabled: !!notificationId
  })
}
